import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, AlertController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

import { UserProvider } from '../../providers/user';
import { TeamappProvider } from '../../providers/teamapp';
/**
 * Generated class for the IdeapoolAddPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-ideapool-add',
  templateUrl: 'ideapool-add.html',
})
export class IdeapoolAddPage {

  ideaForm: FormGroup;

  title: string;
  category: string;
  anonymous: number;
  description: string;

  categorys: any = [];

  constructor(public navCtrl: NavController, public viewCtrl: ViewController, public navParams: NavParams, public userProvider: UserProvider, private formBuilder: FormBuilder, public alertCtrl: AlertController, public teamappProvider: TeamappProvider) {
      this.ideaForm = this.formBuilder.group({
          title: ['', Validators.required],
          category: ['', Validators.required],
          anonymous: ['', Validators.required],
          description: ['', Validators.required],
      });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad IdeapoolAddPage');
    this.loadCategorys();
  }

  loadCategorys() {
    this.teamappProvider.http_request('action=get_categorys', 'idea', false, true).then(data => {
      let categoryData: any = data;
      if(!categoryData.error) {
          this.categorys = categoryData;

          if(this.categorys.length > 0) {
              this.ideaForm = this.formBuilder.group({
                  title: ['', Validators.required],
                  category: ['', Validators.required],
                  anonymous: ['', Validators.required],
                  description: ['', Validators.required],
              });
          } else {
              this.ideaForm = this.formBuilder.group({
                  title: ['', Validators.required],
                  anonymous: ['', Validators.required],
                  description: ['', Validators.required],
              });
          }
      }
    });
  }

  submitIdea() {
    this.teamappProvider.http_request('action=add_idea&add_title='+this.title+'&add_content='+this.description+'&add_category='+this.category+'&add_anonym='+this.anonymous, 'idea', false, true).then(data => {
        if(data) {
            const alert = this.alertCtrl.create({
                title: 'Erfolgreich!',
                subTitle: 'Der Verbesserungsvorschlag wurde abgeschickt und wird schnellstmöglichst überprüft!',
                buttons: ['OK']
            });
            alert.present();
            this.closeModal();
        }
    });
  }

  closeModal() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/ideapool-add/ideapool-add.ts